{
  "$id": "wealthlane://forms/role-publish/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "role_publish_fields",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/sourceRoleId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        },
        {
          "scope": "#/properties/destinationCompanyId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        }
      ]
    }
  ]
}
